import React from 'react';
import PropTypes from 'prop-types';

/**
 * EmptyState Component 
 * Displays a message when no data is available.
 * 
 * @param {Object} props - Component props
 * @param {string} props.message - The message to display
 */
const EmptyState = ({ message }) => {
    return (
        <div className="text-center p-4">
            <p className="mb-0">{message}</p>
        </div>
    );
};
EmptyState.propTypes = {
    message: PropTypes.string.isRequired
};

export default EmptyState;